import { useEffect, useState } from 'react';

/**
 * The value, held back until the artist stops typing.
 *
 * The catalog search is a server read, and firing one per keystroke would put a
 * request behind every letter of a track title.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
